import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d19abe38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "file-icon--container" }
const _hoisted_2 = ["src"]

import { computed } from "vue";
import { useFileIcon } from "@/views/cloud-disk/component/cloud-file-icon/index";
import fileImg from "@/assets/images/file-img.png";


import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "CloudFileIcon",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  fileType: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props

const fileIconMap = useFileIcon();



const fileUrl = computed(() => fileIconMap?.[props.fileType] || fileImg);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _unref(fileUrl),
      alt: ""
    }, null, 8, _hoisted_2)
  ]))
}
}

})